var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-menu',{attrs:{"menu":_vm.menu,"width":_vm.width,"showOneChild":_vm.showOneChild},on:{"toggle-collapse":_vm.onToggleCollapse}})
}
var staticRenderFns = []

export { render, staticRenderFns }